import { useTranslation } from "react-i18next";

/* ──────────────────────────────────────────────────────────────────
 * TaxonomyVersionBadges — schema/version chips shown by both taxonomy
 * tabs. Each taxonomy carries its own version, so the badges live in
 * the tab rather than in the page header.
 * ────────────────────────────────────────────────────────────────── */

interface TaxonomyVersionBadgesProps {
  schemaVersion?: string;
  version?: string;
}

export const TaxonomyVersionBadges = ({
  schemaVersion,
  version,
}: TaxonomyVersionBadgesProps) => {
  const { t } = useTranslation("settings");

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md border bg-muted/40 text-xs font-mono">
        {t("taxonomy.schemaBadge", { version: schemaVersion || "—" })}
      </span>
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md border bg-muted/40 text-xs font-mono">
        {t("taxonomy.versionBadge", { version: version || "—" })}
      </span>
    </div>
  );
};

export default TaxonomyVersionBadges;
